import css from 'styled-jsx/css';

const staticStyles = css.global`
  .UserTagLogsPage__filters {
    display: grid;
    grid-template-columns: repeat(4, minmax(160px, 1fr)) repeat(2, minmax(140px, 1fr)) auto auto;
    gap: 12px;
    align-items: center;
    padding: 16px;
    margin-bottom: 24px;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);

    .BaseSelectField,
    .BaseTextField {
      width: 100%;
      margin-bottom: 0;
    }

    .BaseTextField__inp {
      min-height: 38px;
    }

    input[type='date'] {
      padding-right: 38px;
    }

    input[type='date']::-webkit-calendar-picker-indicator {
      position: absolute;
      top: 50%;
      right: 12px;
      width: 16px;
      height: 16px;
      margin: 0;
      transform: translateY(-50%);
      cursor: pointer;
    }

    @media (max-width: 1200px) {
      grid-template-columns: repeat(3, minmax(160px, 1fr));
    }

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .UserTagLogsTable .ReactDataTable__wrapper .ReactDataTable tr {
    grid-template-columns: 110px minmax(180px, 1.2fr) minmax(180px, 1.2fr) 110px 130px minmax(280px, 1.4fr) 200px !important;
    grid-template-rows: minmax(64px, auto);
  }

  .UserTagLogsTable__actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 12px;
  }

  .UserTagLogsTable .ReactDataTable__thead-cell,
  .UserTagLogsTable .ReactDataTable__tbody-cell {
    display: flex;
    align-items: center;
    text-align: left !important;
  }

  .UserTagLogsTable .ReactDataTable__wrapper .ReactDataTable .ReactDataTable__noData {
    display: flex !important;
    grid-template-columns: 1fr !important;

    td {
      width: 100%;
      justify-content: center;
      text-align: center;
    }
  }

  .UserTagLogsTable__user {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .UserTagLogsTable__user-name {
    font-weight: 500;
  }

  .UserTagLogsTable__user-email {
    color: #8b929b;
    font-size: 12px;
  }

  .UserTagLogsTable__tag-value {
    display: inline-block;
    padding: 3px 8px;
    border: 1px solid #d7dde5;
    border-radius: 4px;
    background: #f8f9fb;
    color: #697482;
    line-height: 1.2;
  }

  .UserTagLogsTable__change {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    align-items: center;
  }

  .UserTagLogsTable__tag,
  .UserTagLogsTable__none {
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 12px;
  }

  .UserTagLogsTable__tag {
    background: #e6f7e1;
    color: #3d9b32;
  }

  .UserTagLogsTable__none {
    background: #f0f2f4;
    color: #9aa1aa;
  }

  .UserTagLogsTable__arrow {
    color: #9aa1aa;
  }

  .UserTagLogsTable__type {
    display: inline-block;
    padding: 3px 8px;
    border-radius: 3px;
    color: #fff;
    font-size: 12px;
    text-transform: capitalize;
  }

  .UserTagLogsTable__type--add {
    background: #67c34a;
  }

  .UserTagLogsTable__type--remove {
    background: #f06464;
  }
`;

export { staticStyles };
